<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="身份证号" prop="idCard">
                <el-input v-model="dataForm.idCard" placeholder="身份证号"></el-input>
            </el-form-item>
            <el-form-item label="出生日期" prop="birthDay">
                <!--  <el-input v-model="dataForm.birthDay" placeholder="出生日期"></el-input>-->
                <el-date-picker v-model="dataForm.birthDay" type="datetime" placeholder="出生日期"
                                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                                style="width:50%">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="dataForm.phone" placeholder="手机号"></el-input>
            </el-form-item>
            <!-- <el-form-item label="邮箱" prop="email">
                <el-input v-model="dataForm.email" placeholder="邮箱"></el-input>
            </el-form-item> -->
            <el-form-item label="联系地址" prop="address">
                <el-input v-model="dataForm.address" placeholder="联系地址"></el-input>
            </el-form-item>
            <!-- <el-form-item label="身份证正面路径" prop="idcardFacePath">
                 <el-input v-model="dataForm.idcardFacePath" placeholder="身份证正面路径"></el-input>
             </el-form-item>
             <el-form-item label="身份证正面路径" prop="idcardBackPath">
                 <el-input v-model="dataForm.idcardBackPath" placeholder="身份证正面路径"></el-input>
             </el-form-item>
             <el-form-item label="手写签名路径" prop="signPath">
                 <el-input v-model="dataForm.signPath" placeholder="手写签名路径"></el-input>
             </el-form-item>-->
            <el-form-item label="是否启用" prop="isEnable">
                <el-radio-group v-model="dataForm.isEnable">
                    <el-radio :label="0">禁用</el-radio>
                    <el-radio :label="1">启用</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        idCard: '',
        birthDay: '',
        phone: '',
        email: '',
        address: '',
        idcardFacePath: '',
        idcardBackPath: '',
        signPath: '',
        isEnable: '',
        creator: '',
        createDate: '',
        updater: '',
        updateDate: '',
        status: '',
        userId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        idCard: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        birthDay: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        phone: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // email: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isEnable: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/plat/info/user/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/info/user/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
